module.exports = __webpack_public_path__ + "img/logo.640a3caa.svg";